<template>
    <b-table striped hover small responsive
    :items="items"
    :fields="fields"
    :filter="filter"
    :per-page="perPage"
    :editImageProp="editImage"
    :current-page="currentPage"
    selectable
    @row-selected="onRowSelected"
    select-mode="single">
      <template v-slot:cell(actions)="row">
        <b-button size="sm" @click.stop="ClickOnEditButton(row)" id="transparent" v-if="isEdit">
          <b-img :src='editImage'/>
        </b-button>
        <b-button size="sm" @click.stop="ClickOnDeleteButton(row)" id="transparent" v-if="isDelete">
          <b-img :src='deleteImage'/>
        </b-button>
      </template>
      <template v-slot:cell(allUsers)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(allParam)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(settingsAdditionalVisible)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(is_deleted)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(is_payed)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(mailed)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(revoked)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(balanceRollover)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(display)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
      <template v-slot:cell(fillIn)="data">
        <b-form-checkbox disabled v-model="data.value"/>
      </template>
    </b-table>
</template>

<script>
export default {
  props: {
    isEdit: null,
    isDelete: null,
    items: null,
    fields: null,
    filter: null,
    perPage: null,
    currentPage: null,
    editImageProp: null
  },
  data () {
    return {
      deleteImage: require('@/assets/img/document_delete.png'),
      editImage: require('@/assets/img/document_edit.png')
    }
  },
  methods: {
    pagination () {
      this.$emit('input', this.items.length)
    },
    ClickOnEditButton (row) {
      this.$emit('ClickOnEditButton', row.item)
    },
    ClickOnDeleteButton (row) {
      this.$emit('ClickOnDeleteButton', row.item)
    },
    onRowSelected (selected) {
      if (selected.length) { this.$emit('RowSelected', selected[0]) } else { this.$emit('RowSelected', null) }
    }
  },
  mounted () {
    if (this.editImageProp) this.editImage = this.editImageProp
  },
  watch: {
    items: function (val) {
      this.pagination()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/BasicTable.vue